/* eslint-disable */
// ** React Imports
import { Suspense, lazy } from "react";
import ReactDOM from "react-dom";

import * as Sentry from "@sentry/react";
// import { BrowserTracing } from "@sentry/tracing";

//Test
// ** Redux Imports
import { Provider } from "react-redux";
import { store } from "./redux/storeConfig/store";

// ** Toast & ThemeColors Context
import { ToastContainer } from "react-toastify";
import { ThemeContext } from "./utility/context/ThemeColors";

// ** Custom_spinner (Splash Screen)
import Spinner from "./@core/components/spinner/FallbackSpinner";

// ** Ripple Button
import "./@core/components/ripple-button";

// ** PrismJS
import "prismjs";
import "prismjs/themes/prism-tomorrow.css";
import "prismjs/components/prism-jsx.min";

// ** React Perfect Scrollbar
import "react-perfect-scrollbar/dist/css/styles.css";

// ** React Toastify
import "@styles/react/libs/toastify/toastify.scss";

// ** Core styles
import "./@core/assets/fonts/feather/iconfont.css";
import "./@core/scss/core.scss";
import "./assets/scss/style.scss";

import "./tailwind.output.css";

// ** Service Worker
import * as serviceWorker from "./serviceWorker";

// ** Auth Provider
import { AuthProvider } from "../src/hooks/useAuth";

// ** App Data Provider
import { AppDataProvider } from "../src/hooks/useAppData";

// ** app.uzeli.com migration banner (shown on every page, incl. login)
import NewAddressBanner from "./@core/components/NewAddressBanner";

import { RedirectProvider } from "./hooks/useRedirect";
import DamServerSocketProvider from "./dam-socket";
import { SocketProvider } from "./views/Locations/containers/SocketContext";

// ** Lazy load app
const LazyApp = lazy(() => import("./App"));

Sentry.init({
  dsn: "https://b4277ed9957f44a2b1258cd165eabfca@o123862.ingest.sentry.io/6196115",
  // integrations: [new BrowserTracing()],

  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  // tracesSampleRate: 1.0,
});

ReactDOM.render(
  <Provider store={store}>
    <ToastContainer newestOnTop />
    <NewAddressBanner />
    <RedirectProvider>
      <AuthProvider>
        <AppDataProvider>
          <Suspense fallback={<Spinner />}>
            <ThemeContext>
              <DamServerSocketProvider>
                <SocketProvider>
                  <LazyApp />
                </SocketProvider>
              </DamServerSocketProvider>
            </ThemeContext>
          </Suspense>
        </AppDataProvider>
      </AuthProvider>
    </RedirectProvider>
  </Provider>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about list workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
